const AcademicDetails = () => {
    return (
        <div id="top" className="vision-card">

            <h3>ACADEMIC DETAILS</h3>

            <div className="table-section-wrap">
                <table className="table-section">
                    <thead>
                        <tr>
                            <th colSpan="2">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        flexWrap: "wrap",
                                        width: "100%",
                                    }}
                                >
                                    <span>School Infrastructure Details</span>

                                    <div style={{ textAlign: "right" }}>
                                        <div>55124-NAV JEEVAN INTERNATIONAL NAVJEEVANNAGAR GORAKHPUR UP</div>
                                        <div>Date:</div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <br />
                        <tr>
                            <th>SUBJECTS OFFERED FOR CLASS 10</th>
                            <th>SUBJECTS OFFERED FOR CLASS 12</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>
                                002---HINDI COURSE-A <br />                              
                                041---MATHEMATICS<br />
                                086---SCIENCE <br />
                                087---SOCIAL SCIENCE                           
                            </td>

                            <td>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AcademicDetails;